import { usePersistentStore, STORAGE_KEY } from '~/stores/persistent';

export default defineNuxtPlugin(() => {
  // Get the store instance
  const store = usePersistentStore();

  // Subscribe to any state changes in the store
  store.$subscribe((mutation, state) => {
    // We need to prepare the state to be stored in JSON.
    // Specifically, we must convert the Map to a plain Array.
    const stateToStore = {
      ...state,
      userPreferences: Array.from(state.userPreferences.entries()),
    };

    // Store the prepared state in localStorage
    localStorage.setItem(STORAGE_KEY, JSON.stringify(stateToStore));
  });
});
